// extracted by mini-css-extract-plugin
module.exports = {"hidden":"infoDetailRecommendList_hidden__f1tb4","textEmphasis":"infoDetailRecommendList_textEmphasis__G1Pzb","recommendList":"infoDetailRecommendList_recommendList__kkrwZ"};